import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  CustomInput,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { IAuthReduxProps, IToken, IGoalEdit0, ITarget } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import CreatableSelect from 'react-select/creatable';
import { getGoals, addOrEditGoal } from '../../flux/actions/goalActions';
import { getGoal_societe_defaults, addOrEditGoal_societe_default } from '../../flux/actions/goalsocietedefaultActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faEdit, faExternalLinkAlt, faPen, faPlus, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import NumberFormat from 'react-number-format';
import { constants } from '../../types/constants';

const GoalEdit = ({
  modal,
  setModal,
  modalData,
  selectedUserGoal,
  societeGoal,
  getGoalsFromDate,
  addOrEditGoal,
  addOrEditGoal_societe_default,
  auth
 }: IGoalEdit0) => {
  const goalTargetOptions = [{value: "USER", label: `Le commercial ${selectedUserGoal?.LOGIN || ""}`}, {value: "ALL", label: societeGoal?.id !== "ALL" ? `Tout le projet ${societeGoal?.LIBELE}` : societeGoal?.LIBELE}, {value: "ALLALL", label: "Tous les projets"}];
  const [goalTarget, setGoalTarget] = useState<any>(goalTargetOptions.find(e => e.value === "USER"));
  const [goalVValue, setGoalVValue] = useState<any>(0);
  const [goalEValue, setGoalEValue] = useState<any>(0);
  const [goalRValue, setGoalRValue] = useState<any>(0);
  const [goalLValue, setGoalLValue] = useState<any>(0);
  const [commentValue, setCommentValue] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);

  const alert = useAlert();

  useEffect(() => {
    if(modalData){
      const goalsFromDate = getGoalsFromDate(modalData?.month, modalData?.year);console.log("goalsFromDate", goalsFromDate)
      setGoalVValue(goalsFromDate?.goalV)
      setGoalEValue(goalsFromDate?.goalE)
      setGoalRValue(goalsFromDate?.goalR)
      setGoalLValue(goalsFromDate?.goalL)
      setCommentValue(goalsFromDate?.comment || '')
    }
    else{
      setGoalVValue(undefined)
      setGoalEValue(undefined)
      setGoalRValue(undefined)
      setGoalLValue(undefined)
      setCommentValue('')
    }
  }, [modalData])

  const modalClosedHandle = () => {
    // setModalData(undefined)
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const handleToggle = () => setModal(!modal);

  const handleGoalTargetChange = data => {
    setGoalTarget(data || '');
  }
  const commentChangeHandler = (e: ITarget) => setCommentValue(e.target.value);

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };

  useEffect(() => {
    if(goalTarget?.value === "USER")
      setGoalTarget(e => ({...e, label: `Le commercial ${selectedUserGoal?.LOGIN || ""}`}))
    else if(goalTarget?.value === "ALL")
      setGoalTarget(e => ({...e, label: societeGoal?.id !== "ALL" ? `Tout le projet ${societeGoal?.LIBELE}` : societeGoal?.LIBELE}))
  }, [selectedUserGoal, societeGoal])
  
  const callback = (success) => {
    if(success){
      setReEnable(true);
      setModal(false);
      if(alert.removeAll && typeof alert.removeAll === "function")
        alert.removeAll()
      alert.success("Objectif modifié avec succès");
      // setFormulaName('');
      // setFormulaNameAuto(true);
      // setFormulaEntries(defaultFormulaEntries);
      // setUserFormulasOpen(true);
      // setIsChangeFormulaOpen(false);
      // setIsCreateFormulaOpen(false);
      // changeFormulaInstanceHandle(success.id)
      // refresh();
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const addGoalHandle = async () => {
    setDisableSubmit(true)
    if(modalData){
      if(goalTarget?.value === "USER")
        addOrEditGoal(modalData.month, modalData.year, selectedUserGoal?.id, societeGoal?.id, goalVValue, goalEValue, goalRValue, goalLValue, auth?.user?.id, commentValue, callback)
      else
        addOrEditGoal_societe_default(modalData.month, modalData.year, goalTarget?.value === "ALLALL" ? "ALL" : societeGoal?.id, goalVValue, goalEValue, goalRValue, goalLValue, auth?.user?.id, commentValue, callback)
    }
  }

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Modification des Objectifs</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer" style={{padding: 0}}>
            <div className="goalCalendarYear">{!!modalData && `${constants.DP_MONTHS[modalData.month - 1]} ${modalData.year}`}</div>
            <Row className="justify-content-center">
              <Col xs="12">
                <FormGroup>
                  <Label for="goalTarget">Pour :</Label>
                  <Select
                    id="goalTarget"
                    className="reactselect"
                    classNamePrefix="react-select"
                    defaultValue={goalTargetOptions[1]}
                    value={goalTarget}
                    onChange={handleGoalTargetChange}
                    isClearable={false}
                    loadingMessage={() => 'Chargement...'}
                    noOptionsMessage={() => 'pas de resultat'}
                    isSearchable={false}
                    options={goalTargetOptions}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="goalV">Objectif Ventes</Label>
                  <InputGroup className="quantityInputGroup">
                    <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="goalV" pattern="[0-9]*" placeholder="Objectif Ventes..." value={goalVValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setGoalVValue(e.value ? +e.value : 0)}/* onChange={prixpartChangeHandler}*/ className="form-control" />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>DH</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="goalE">Objectif Encaissements Ventes</Label>
                  <InputGroup className="quantityInputGroup">
                    <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="goalE" pattern="[0-9]*" placeholder="Objectif Encaissements Ventes..." value={goalEValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setGoalEValue(e.value ? +e.value : 0)}/* onChange={prixpartChangeHandler}*/ className="form-control" />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>DH</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="goalR">Objectif Recouvrement</Label>
                  <InputGroup className="quantityInputGroup">
                    <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="goalR" pattern="[0-9]*" placeholder="Objectif Recouvrement..." value={goalRValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setGoalRValue(e.value ? +e.value : 0)}/* onChange={prixpartChangeHandler}*/ className="form-control" />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>DH</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="goalL">Objectif Livraison</Label>
                  <InputGroup className="quantityInputGroup">
                    <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="goalL" pattern="[0-9]*" placeholder="Objectif Livraison..." value={goalLValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setGoalLValue(e.value ? +e.value : 0)}/* onChange={prixpartChangeHandler}*/ className="form-control" />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>DH</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="comment">Commentaire</Label>
                  <Input id="comment" placeholder="Commentaire..." value={commentValue} onChange={commentChangeHandler} />
                </FormGroup>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col xs="11" md="7">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={addGoalHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Valider</Button>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { addOrEditGoal, addOrEditGoal_societe_default })(GoalEdit);
